/**
 * Contains all constant Action name
 */

export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const SET_FLASH = 'SET_FLASH';
export const TOKEN_VALIDATION = 'TOKEN_VALIDATION';

export const BROWSE_TASKS = 'BROWSE_TASKS';
export const UPDATE_TASK_SCOPE = 'UPDATE_TASK_SCOPE';
export const REORDER_FOLLOWING_TASKS = 'REORDER_FOLLOWING_TASKS';
export const REORDER_REGISTERED_TASKS = 'REORDER_REGISTERED_TASKS';
export const FOLLOWING_TASKS = 'FOLLOWING_TASKS';
export const REGISTERED_TASKS = 'REGISTERED_TASKS';
export const UNFOLLOW_TASK = 'UNFOLLOW_TASK';
export const EDIT_TASK = 'EDIT_TASK';
export const EDIT_TASK_SKILLS = 'EDIT_TASK_SKILLS';
export const PROJECT_LIST = 'PROJECT_LIST';
export const SKILL_LIST = 'SKILL_LIST';
export const USER_LIST = 'USER_LIST';
export const TASK_COMPLETION_TYPES = 'TASK_COMPLETION_TYPES';
export const TASK_COMPLETION_ITEMS = 'TASK_COMPLETION_ITEMS';
export const ADD_TASK_COMPLETION_ITEM = 'ADD_TASK_COMPLETION_ITEM';
export const REMOVE_TASK_COMPLETION_ITEM = 'REMOVE_TASK_COMPLETION_ITEM';
export const GET_TASK_EDIT_DETAILS = 'GET_TASK_EDIT_DETAILS';
export const TASK_EDIT_DEFAULTS = 'TASK_EDIT_DEFAULTS';
export const TASKS_OBJECT_ADD = 'TASKS_OBJECT_ADD';
export const TASKS_OBJECT_REMOVE = 'TASKS_OBJECT_REMOVE';
export const EDIT_TASK_COMPLETION_ITEM = 'EDIT_TASK_COMPLETION_ITEM';
export const SET_TASK_COMPLETION_ITEM = 'SET_TASK_COMPLETION_ITEM';
export const RESORT_TASK_COMPLETION_ITEM = 'RESORT_TASK_COMPLETION_ITEM';
export const UNSET_EDITING_INDEX = 'UNSET_EDITING_INDEX';
export const NEW_TASK_DATES = 'NEW_TASK_DATES';
export const SET_TASK_DATE = 'SET_TASK_DATE';
export const SET_TASK_LOCATION = 'SET_TASK_LOCATION';
export const REORDER_TASK_MEDIA = 'REORDER_TASK_MEDIA';
export const SHOW_HINT_TOGGLE = 'SHOW_HINT_TOGGLE';
export const ADD_MEDIA_URL = 'ADD_MEDIA_URL';
export const CHANGE_ACTIVE_TAB = 'CHANGE_ACTIVE_TAB';
export const ORGANIZER_TASKS = 'ORGANIZER_TASKS';
export const ORGANIZER_PROJECTS = 'ORGANIZER_PROJECTS';
export const PROJECTS_SELECT = 'PROJECTS_SELECT';
export const SET_FILTER_FIELDS = 'SET_FILTER_FIELDS';
export const GET_PROJECT_DETAILS = 'GET_PROJECT_DETAILS';
export const EDIT_PROJECT = 'EDIT_PROJECT';
export const PROJECTS_OBJECT_ADD = 'PROJECTS_OBJECT_ADD';
export const PROJECTS_OBJECT_REMOVE = 'PROJECTS_OBJECT_REMOVE';
export const REORDER_PROJECT_MEDIA = 'REORDER_PROJECT_MEDIA';
export const PROJECT_EDIT_DEFAULTS = 'PROJECT_EDIT_DEFAULTS';
export const EDIT_CATEGORIES = 'EDIT_CATEGORIES';
export const SET_USER_ID = 'SET_USER_ID';
export const RESET_TASK_STATE = 'RESET_TASK_STATE';
export const RESET_PROJECT_STATE = 'RESET_PROJECT_STATE';
export const GET_PROJECT_TASKS = 'GET_PROJECT_TASKS';
export const SET_ALLOWED_CHANNEL_ACCESS = 'SET_ALLOWED_CHANNEL_ACCESS';
export const SET_PROJECT_ID = 'SET_PROJECT_ID';
export const SHOW_GALLERY = 'SHOW_GALLERY';
export const SET_IMAGES = 'SET_IMAGES';
export const SET_ACTIVE_IMAGE = 'SET_ACTIVE_IMAGE';
export const SET_DATA_LOADING = 'SET_DATA_LOADING';
export const TASK_COMPLETION_LIST = 'TASK_COMPLETION_LIST';
export const SET_KARMA_POINTS = 'SET_KARMA_POINTS';

export const GET_CHAT_USER_CHANNELS = 'GET_CHAT_USER_CHANNELS';
export const LOADING_CHAT_USER_CHANNELS = 'LOADING_CHAT_USER_CHANNELS';
export const GET_CHAT_PRIVATE_LIST = 'GET_CHAT_PRIVATE_LIST';
export const LOADING_CHAT_PRIVATE_LIST = 'LOADING_CHAT_PRIVATE_LIST';

export const GET_BROWSE_ID = 'GET_BROWSE_ID';
export const GET_BROWSE_TASK_SKILLS = 'GET_BROWSE_TASK_SKILLS';
export const GET_BROWSE_TASK_INTERESTS = 'GET_BROWSE_TASK_INTERESTS';
export const BROWSE_LOADER = 'BROWSE_LOADER';
export const SET_ERROR = 'SET_ERROR';

export const USER_SET_PROFILE = 'USER_SET_PROFILE';
export const USER_SET_ID = 'USER_SET_ID';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js